function setScrollTop(el,n=300) {
    var T = document.getElementById(el);
    let top = T.getBoundingClientRect().top; // console.log(;
    window.scrollTo({
        top: top-50 ,
        behavior: "smooth",
    });
}
export default setScrollTop;
